<div [ngStyle]="{'width': size+'px', 'height': size+'px'}" class="initiales_name satisfaction_{{satisfactionType}} after-inline">
  <span>{{user.first_name[0]}} {{user.last_name[0]}}</span>
</div>